<template>
	<div class="form-group">
    <label class="form-label">Credentials</label>
    <div class="input-group">
      <span class="input-group-prepend">
        <select class="form-control" v-model="credentialsType">
          <option value="token" selected>Token</option>
          <option value="secret">Secret</option>
          <option value="public-key">Public Key</option>
          <option value="private-key">Private Key</option>
        </select>
      </span>
      <input type="text" class="form-control" name="credentials" v-model="credentialsInput" placeholder="Enter Credentials">
      <span class="input-group-append">
        <button class="btn btn-grey" type="button" @click="addCredentials"><i class="d-block fe fe-plus"></i></button>
      </span>
    </div>
    <small class="d-block text-danger">{{ errors.first('credentials') }}</small>
    <div class="added-data">
      <div v-for="(data, index) in credentialsArray" class="added-data__item" :key="data.id">
        {{ Object.keys(data)[0] }}: <a href="javascript:void(0);" class="show-password" @click="$emit('showCredentialPassword', data[Object.keys(data)[0]])"><small>&#8902;&#8902;&#8902;&#8902;</small></a><a href="javascript:void(0);" class="added-data__icon" @click="removeCredentials(index)"><i class="fe fe-trash"></i></a>
      </div>
    </div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Credentials',
	inject: ['$validator'],
	props: {
		credentialsList: Array
	},
	data() {
		return {
			credentialsType: "token",
			credentialsInput: "",
			credentialsArray: []
		}
	},
	mounted() {
		
	},
	methods: {
		addCredentials: function() {
			if (this.credentialsInput != "") {
				this.credentialsArray.push({ [this.credentialsType]: this.encrypt(this.credentialsInput) });
				this.resetCredentialsType();
				this.resetCredentialsInput();
			}
		},
		removeCredentials: function(index) {
			this.credentialsArray.splice(index, 1);
		},
		resetCredentialsType: function() {
			this.credentialsType = "token";
		},
		resetCredentialsInput: function() {
			this.credentialsInput = "";
		}
	},
	watch: {
		credentialsArray: {
			handler: function() {
				this.$emit('update:value', this.credentialsArray)
			},
			deep: true
		},
		credentialsList: function() {
			this.credentialsArray = this.credentialsList;
		}
	}
}
</script>